export default __webpack_public_path__ + "static/media/photo8.b8fefe10.jpg";